export enum TournamentDivisionTeamStatusEnum {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    REJECTED = 'rejected',
  }
  